const hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };

export const getOppositePlacement = (placement) =>
  placement.replace(/left|right|bottom|top/g, (matched) => hash[matched]);
